export function headerFunc() {
  // ヘッダーを取得
  const header = document.querySelector('.site-header');
  const headerContainer = document.getElementById('site-header-container');
  // テーマディレクトリを取得
  const themeDir = document.querySelector('body').dataset.stylesheetDir;

  // ヘッダーにお知らせバーを追加
  const headerBar = document.createElement('div');
  headerBar.classList.add('header-bar');
  headerBar.textContent = '島根県の戸建て住宅・集合住宅・工場・ビルの塗り替えは塗装のプロにお任せください';
  header.prepend(headerBar);

  // ヘッダーに電話番号、Instagramアイコンを追加
  const headerContact = document.createElement('div');
  headerContact.classList.add('header-contact');
  headerContact.innerHTML = `
    <a href="tel:0855-22-0808" class="header-contact__tel">
      <img src="${themeDir}/img/common/icon_tel.svg" class="is-icon" alt="TEL">
      <span class="is-number">0855-22-0808</span>
      <span class="is-text">受付時間  8:00~17:00</span>
    </a>
    <div class="header-contact__instagram">
      <a href="https://www.instagram.com/harimaya_tosho_penki/" target="_blank">
        <img src="${themeDir}/img/common/icon_instagram.svg" alt="Instagram">
      </a>
    </div>
  `;
  headerContainer.appendChild(headerContact);

  // 追従電話アイコンを追加（SP）
  const headerFixedTel = document.createElement('div');
  headerFixedTel.classList.add('header-fixed-tel');
  headerFixedTel.innerHTML = `
    <a href="tel:0855-22-0808">
      <img src="${themeDir}/img/common/icon_tel.svg" class="is-icon" alt="TEL">
    </a>
  `;
  document.body.appendChild(headerFixedTel);

  /**
   * パンくずリストのカスタマイズ
   */
  const breadcrumbItems = document.querySelectorAll('.breadcrumb-list__item');
  const homeUrl = document.querySelector('body').dataset.homeUrl;
  if (breadcrumbItems.length > 0) {
    breadcrumbItems.forEach((item) => {
      const child = item.querySelector('a, span');
      if (child.innerText === '施工事例') {
        // aタグへ変更
        const aTag = document.createElement('a');
        aTag.setAttribute('href', homeUrl + 'works');
        aTag.innerText = '施工事例';
        item.innerHTML = '';
        item.appendChild(aTag);
      } else if (child.innerText === 'コラム') {
        // aタグへ変更
        const aTag = document.createElement('a');
        aTag.setAttribute('href', homeUrl + 'column');
        aTag.innerText = 'コラム';
        item.innerHTML = '';
        item.appendChild(aTag);
      } else if (child.innerText === '未分類') {
        // 削除
        item.remove();
      }

      // hrefに「/works/category/」を含む場合
      const href = child.getAttribute('href');
      if (href !== null) {
        if (href.includes('/works/category/')) {
          const termId = document.querySelector('body').dataset.termId;
          child.setAttribute('href', homeUrl + 'works/' + '?term=' + termId);
        } else if (href.includes('/column/category/')) {
          const termId = document.querySelector('body').dataset.termId;
          child.setAttribute('href', homeUrl + 'column/' + '?term=' + termId);
        }
      }
    });
  }

  // ヘッダーの高さ分bodyのpadding-topを設定
  settingBodyPaddingTop();
  addEventListener('resize', settingBodyPaddingTop);

  /**
   * ハンバーガーメニューにCTAを追加
   */
  const burgerMenuWrpper = document.querySelector('.vk-mobile-nav-menu-outer');
  const burgerCta = document.createElement('div');
  burgerCta.classList.add('p-burger-cta');
  burgerCta.innerHTML = `
    <div class="p-burger-cta__tel">
      <a href="tel:0855-22-0808" class="p-burger-cta__tel-number">
        <img src="${themeDir}/img/common/telnumber.svg" alt="TEL">
      </a>
      <p class="p-burger-cta__tel-text">【受付時間】8：00～17：00 【定休日】日曜祝日・第二・第四土曜</p>
    </div>
    <div class="p-burger-cta__buttons">
      <a href="${homeUrl}contact" class="p-burger-cta__button is-contact">
        <span class="is-icon"></span>
        <span class="is-text">お問い合わせ</span>
      </a>
      <a href="https://line.me/R/ti/p/@028qaesg" class="p-burger-cta__button is-line" target="_blank">
        <span class="is-icon"></span>
        <span class="is-text">LINEで相談</span>
      </a>
    </div>
  `;
  burgerMenuWrpper.prepend(burgerCta);
}

const settingBodyPaddingTop = () => {
  const headerHeight = document.getElementById('site-header').clientHeight;
  document.body.style.paddingTop = headerHeight + 'px';
};
